import React from "react";
import "./errorpage.css";
import { Seo } from "./Seo";

function ErrorPage() {
  return (
    <main className="error-page" aria-labelledby="error-page-title">
      <Seo title="Page Not Found" path="/404" noIndex />
      <div className="error-page__glow error-page__glow--one" aria-hidden="true" />
      <div className="error-page__glow error-page__glow--two" aria-hidden="true" />

      <section className="error-page__card">
        <p className="error-page__eyebrow">Annwesha · Page not found</p>
        <div className="error-page__code" aria-hidden="true">
          <span>4</span>
          <span className="error-page__zero">0</span>
          <span>4</span>
        </div>
        <h1 id="error-page-title">This page wandered off the path.</h1>
        <p className="error-page__message">
          The link may be outdated, or the page may have moved. Let&apos;s take you
          back to Annwesha.
        </p>
        <a className="error-page__button" href="/">
          <span aria-hidden="true">←</span>
          Return to home
        </a>
      </section>

      <p className="error-page__footer">Department of Bengali · S. S. College, Hailakandi</p>
    </main>
  );
}

export default ErrorPage;
